import {
    PREDICTION_HISTOGRAM_DRAW_BAR,
    PREDICTION_HISTOGRAM_DRAW_PAINT,
    HISTOGRAM_CHART,
    SCATTERPLOT_CHART,
    PREDICTION,
    ACTUAL,
    SEEDATA,
    COMBINED,
    COMBINEDSTACKEDBARCHART,
    COMBINEDGROUPBARCHART,
    PREDICTION_HISTOGRAM_CANVAS_CLEAR,
    PREDICTION_HISTOGRAM_CANVAS_PENCIL,
    BAR_CHART,
    LINE_CHART,
    PARALLEL_COORDINATES_CHART
} from "../../Canvas/Constants";
import classNames from 'classnames';
import {
    histogramPredictionDataset,
    HistogramPrediction,
    brushingDataset,
    BrushingDataSet,
    BrushingPointsBarChart,
} from "../../../Globals/Globals";
import {
    brushingFilterDataset,
    BrushingFilterBarChart
} from '../../../Globals/BrushingFIlterDataset'
import { GraphPredictContext } from "../../Canvas/GraphPredictContext";
import * as React from "react";
import { extent as d3ArrayExtent, histogram, range as d3Range } from "d3-array";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import { min as d3min, max as d3max } from "d3";
import {
    scaleLinear as d3ScaleLinear,
    scalePoint as d3ScalePoint,
    scaleOrdinal as d3ScaleOrdinal
} from "d3-scale";
import * as d3 from "d3";
import { schemeCategory10 as d3SchemeCategory10, event as d3event } from "d3";

import {
    select as d3Select,
    selectAll as d3SelectAll,
    event as d3event1
} from "d3-selection";
import { line as d3Line } from "d3-shape";

import * as aggregation from "../../aggregation/countAggregation";
import { func } from "prop-types";
import { useState } from "react";
import * as interactfuncs from "../../../libtsx/interactfuncs";

import { histogramBrush } from "../../Brushing/HistogramBrush";
import { scatterPlotBrush } from "../../Brushing/ScatterPlotBrush";
import { lineChartBrush } from "../../Brushing/LineChartBrush";
import { parallelCoordinatesPlotBrush } from "../../Brushing/ParallelCoordinatesBrush";
import { barChartBrush, } from "../../Brushing/BarChartBrush";

import CombinedToolBox from "../../Canvas/CombinedToolBox";
import {LogEvents} from '../../../Globals/Globals'
import { PREDICTION_COLOR, REALDATA_COLOR, BRUSHING_COLOR, NO_PREDICTION_COLOR } from "../../../Globals/ColorConstants"
import ScatterPlot from "../ScatterPlot/Scatterplot";
import {clearAllBrushes} from '../../Canvas/MasterGraphConfig'
import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
    ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, LOG_EVENT_TYPE_CHART_BRUSHING_STARTED,
    LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED} from '../../../Globals/LogConstants'
    


interface BarChartStates { }

interface BarChartProps {
    id: string;
    xaxis: string;
    yaxis: string;
    height: number;
    width: number;
    brushValueOptions: {},
    invert: boolean
}




const BarChart: React.FC<BarChartProps> = ({ id, width, height, xaxis, yaxis, brushValueOptions, invert }) => {
    const { grapVisOptions, setgrapVisOptions } = GraphPredictContext();
    console.log(
        "GraphPredictContextBarChart",
        grapVisOptions,
        histogramPredictionDataset
    );

   


    var graphDraw = grapVisOptions["graphDraw"];
    var grapCanvasOptions = grapVisOptions["grapCanvasOptions"];
    var grapCanvasClearToggle = grapVisOptions["grapCanvasClearToggle"];
    var graphOptions = grapVisOptions["graphOptions"];
    var graphType = grapVisOptions["graphType"];
    var graphBrushRefreshOptions = grapVisOptions["graphBrushRefreshOptions"];
   
    console.log('categoriesCount categoriesCount', xaxis, aggregation.loadValues, aggregation.loadValues1)
  
    console.log('BarChart init', id, width, height, xaxis, yaxis)
    
    var categoriesCount: Array<number> = aggregation.loadValues[xaxis];

    var categoriesMap = {};

    var categoriesSave = {}


    categoriesCount.map(function(d, i) {
        if (categoriesMap[d] == null) {
            categoriesMap[d] = 1;
            categoriesSave[d] = 1;

        } else {
            categoriesMap[d] = categoriesMap[d] + 1;
            categoriesSave[d] = categoriesSave[d] + 1;
        }
    });

    if (yaxis != 'Count') {
        var categoriesValueMap = new Map<string, number>();
        var categoriesValues = aggregation.loadValues1;
        
        categoriesValues.map(function(d, i) {
           
                var category = d[xaxis]
                var value = d[yaxis]
            
         
            if (categoriesValueMap[category] == null) {
                categoriesValueMap[category] = value;
                categoriesSave[category] = value;

            } else {
                categoriesValueMap[category] = value + categoriesValueMap[category];
                categoriesSave[category] = value + categoriesSave[category];

            }
        });
    
        Object.keys(categoriesMap).map(function(e) {
            categoriesMap[e] = categoriesValueMap[e] / categoriesMap[e]
            categoriesSave[e] = categoriesSave[e] / categoriesMap[e]
            // categoriesMap[e] = categoriesValueMap[e]
        })

        console.log('categoriesValueMap', categoriesValueMap, categoriesMap)
    }

    var margin = { top: 10, right: 10, bottom: 60, left: 40 };
    var height = height - margin.left - margin.right;
    var width = width - margin.top - margin.bottom;
    console.log("categoriesMap categoriesCount", categoriesMap, categoriesCount);
    var xScaleBand = d3
        .scaleBand()
        .domain(Object.keys(categoriesMap))
        .range([0, width])
        .padding(0.3);
   
    var xAxis = d3AxisBottom(xScaleBand);
    
   
    var maxYaxis
    console.log('BarChart brushValueOptions', graphBrushRefreshOptions)




    var domainMax = d3.max(
        Object.keys(categoriesMap).map(function(e) {
            return categoriesMap[e];
        }))
    domainMax = domainMax+ domainMax*0.1
    const linearYScale = d3
        .scaleLinear()
        .domain([
            0,
            domainMax

        ])
        .nice()
        .range([height, 0]);
        
    var yAxis = d3AxisLeft(linearYScale);
    
    var rectForeground: any = "";

    if (brushingDataset.getActualID(id) == null) {
        var actualDataset = brushingDataset.addActualID(id)
    }
    else
    {
        var actualDataset = brushingDataset.getActualID(id)
    }
        actualDataset.setlinearYScale(linearYScale)
        actualDataset.setSumCategories(categoriesSave)
        actualDataset.height = height
        actualDataset.domainMax = domainMax
        actualDataset.domainMin = 0
        actualDataset.xaxis = xaxis
        actualDataset.yaxis = yaxis
        actualDataset.type = BAR_CHART
        actualDataset.yAxis = yAxis
        actualDataset.categoriesMap = categoriesMap



    var graph: any = "";
    if (yaxis != 'Count') 
    {
        var random = Math.max.apply(null, (Object.values(categoriesMap)))
    var randomLength =domainMax*0.1
            
    
    }
    else
    {
        var random = Math.max.apply(null, (Object.values(categoriesMap)))
    var randomLength = domainMax*0.1
            
    
    }
    if (graphOptions == '') {
        return (
            <>
                {""}
                <svg
                    className={id + "chart"}
                    id={id + "_svg_barchart_draw"}
                    height={height + margin.left + margin.right}
                    width={width + margin.top + margin.bottom}
                >
                    <g
                        transform={"translate(" + margin.left + ", " + margin.top + ")"}
                        id={id + "_svg_barchart"}
                    >
                        <g transform={"translate(0," + height + ")"}>
                            <g
                                transform={"translate(0,0)"}
                                ref={node => d3Select(node).call(xAxis)}
                            ></g>
                        </g>

                        <g ref={node => d3Select(node).call(yAxis)} className={"axisY"}>

                           
                        </g>
                    </g>
                </svg>
            </>
        );
    }
    if (
        graphOptions == PREDICTION
    ) {

       

       
        var actualDataset = brushingDataset.getActualID(id)
        rectForeground = Object.keys(categoriesMap).map(function(e) {
            if (
                histogramPredictionDataset.getPredictionID(id + "_predictRect") !=
                null &&
                histogramPredictionDataset
                    .getPredictionID(id + "_predictRect")
                    .get(id + "_predictRect_" + e) != null &&
                histogramPredictionDataset
                    .getPredictionID(id + "_predictRect")
                    .get(id + "_predictRect_" + e).stopy != null
            ) {
                console.log(
                    "histogramPredictionDataset histogramPredictionDataset ",
                    e,
                    " ",
                    histogramPredictionDataset
                        .getPredictionID(id + "_predictRect")
                        .get(id + "_predictRect_" + e)
                );
                histogramPredictionDataset
                    .getPredictionID(id + "_predictRect")
                    .get(id + "_predictRect_" + e)
                    .setStopHeight(height);


                var length = histogramPredictionDataset
                    .getPredictionID(id + "_predictRect")
                    .get(id + "_predictRect_" + e).stopy;

                return (
                    <rect
                        id={id + "_predictRect_" + e}
                        fill={PREDICTION_COLOR}
                        transform={
                            "translate(" +
                            xScaleBand(e) +
                            "," +
                            linearYScale(length) +
                            ")"
                        }
                        className={id + "_predictRect"}
                        width={xScaleBand.bandwidth()}
                        height={height - linearYScale(length)}
                    />
                );
            } else {
             

                if (
                    histogramPredictionDataset.getPredictionID(id + "_predictRect") ==
                    null
                ) {
                    var histogramPrediction: HistogramPrediction = new HistogramPrediction();

                    histogramPrediction.setStopHeight(height);
                    histogramPrediction.setlinearYScale(linearYScale);
                    histogramPredictionDataset
                        .addPredictionID(id + "_predictRect")
                        .set(id + "_predictRect_" + e, histogramPrediction);
                    histogramPredictionDataset.addInitial(id + "_predictRect")
                } else {
                    if (
                        histogramPredictionDataset
                            .getPredictionID(id + "_predictRect")
                            .get(id + "_predictRect_" + e) != null
                    ) {
                        histogramPrediction = histogramPredictionDataset
                            .getPredictionID(id + "_predictRect")
                            .get(id + "_predictRect_" + e);
                        histogramPrediction.setStopHeight(height);
                        histogramPrediction.setlinearYScale(linearYScale);

                    } else {
                        var histogramPrediction: HistogramPrediction = new HistogramPrediction();
                        histogramPrediction.setStopHeight(height);
                        histogramPrediction.setlinearYScale(linearYScale);
                        histogramPredictionDataset
                            .getPredictionID(id + "_predictRect")
                            .set(id + "_predictRect_" + e, histogramPrediction);
                    }
                }

                return (
                    <rect
                        id={id + "_predictRect_" + e}
                        fill={PREDICTION_COLOR}
                        transform={
                            "translate(" +
                            xScaleBand(e) +
                            "," +
                            linearYScale(randomLength) +
                            ")"
                        }

                        className={id + "_predictRect"}
                        width={xScaleBand.bandwidth()}
                        height={height - linearYScale(randomLength)}
                    />
                );
            }
        });
        console.log("histogramPredictionDatasetUU", histogramPredictionDataset);



        React.useEffect(() => {
            console.log("useEffectBarChart");
            console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);
            console.log("useEffectBarChart", BrushingDataSet.currentGraphType,graphOptions, )
            console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);

            if (
                graphOptions == PREDICTION && document.getElementById(id + "_svg_barchart_draw")
            ) {

                interactfuncs.resizeTopRectBar(id + "_predictRect", xaxis, yaxis, graphType);
            }

         
        }, [graphType, graphOptions]);

        console.log("rectForeground return", rectForeground);
        return (
            <>
                {""}
                <svg
                    className={id + "chart"}
                    id={id + "_svg_barchart_draw"}
                    height={height + margin.left + margin.right}
                    width={width + margin.top + margin.bottom}
                >
                    <g
                        transform={"translate(" + margin.left + ", " + margin.top + ")"}
                        id={id + "_svg_barchart"}
                    >
                        <g transform={"translate(0," + height + ")"}>
                            <g
                                transform={"translate(0,0)"}
                                ref={node => d3Select(node).call(xAxis)}
                            ></g>
                        </g>

                        <g ref={node => d3Select(node).call(yAxis)} className={"axisY"}>

                            {rectForeground}
                        </g>
                    </g>
                </svg>
            </>
        );

    }

    if (graphOptions == SEEDATA) {


        var histogrampredictionInital = histogramPredictionDataset.getInitial(
            id + "_predictRect"
        );
        var actualDataset = brushingDataset.getActualID(id)
        console.log('histogramprediction SEEDATA', histogrampredictionInital, graphType, graphOptions)
        if (histogrampredictionInital == true) {


            var groupBins = Object.keys(categoriesMap).map(function(e) {
                var histogramprediction = histogramPredictionDataset.getPredictionID(
                    id + "_predictRect"
                );
                if (
                    histogramprediction != null &&
                    histogramprediction.get(id + "_predictRect_" + e) != null &&
                    histogramprediction.get(id + "_predictRect_" + e).stopy != null
                ) {
                    var predictionlength = histogramPredictionDataset
                        .getPredictionID(id + "_predictRect")
                        .get(id + "_predictRect_" + e).stopy;
                    return {
                        name: e,
                        actual: categoriesMap[e],
                        prediction: predictionlength,
                        predicted: true
                    };
                } else {
                    return {
                        name: e,
                        actual: categoriesMap[e],
                        prediction: randomLength,
                        predicted: false
                    };
                }
            });

           

            console.log("groupBins", groupBins);
            var barPadding = 0.2;
            var axisTicks = { qty: 5, outerSize: 0, dateFormat: "%m-%d" };

            var xScale0 = d3
                .scaleBand()
                .range([0, width])
                .padding(barPadding);
            var xScale1 = d3.scaleBand();
            var yScale = d3.scaleLinear().range([height, 0]);
            var xAxis_combined = d3
                .axisBottom(xScale0)
                .tickSizeOuter(axisTicks.outerSize);

            xScale0.domain(groupBins.map(d => d.name));
            xScale1.domain(["actual", "prediction"]).range([0, xScale0.bandwidth()]);
            var d3maxPredict = d3.max(groupBins.map(d=>d.prediction))
            var d3maxActual = d3.max(groupBins.map(d=>d.actual))
            var domainYMax = d3.max([d3maxPredict,d3maxActual]) 
            domainYMax =  domainYMax + domainYMax*0.1
            yScale.domain([
                0,
                domainYMax
            ]);
            actualDataset.setlinearYScale(yScale)
            yAxis = d3AxisLeft(yScale) 

          
            var rectBackground = groupBins.map(function(d, i) {
                if (d.predicted == true) {
                    return (
                        <>
                            <g transform={"translate(" + xScale0(d.name) + ",0)"}>
                                <rect
                                    fill={REALDATA_COLOR}
                                    id={id + '#' + '_BarChart_' + xaxis + "_" + yaxis + "_" + d.name}
                                    className={['BarChart_' + xaxis + "_" + yaxis + "_" + d.name+"_"+id , d.name, 'axis--x'].join(" ")}
                                    x={xScale1("actual")}
                                    y={yScale(d.actual)}
                                    width={xScale1.bandwidth()}
                                    height={height - yScale(d.actual)}
                                    onClick={function(dc) {

                                      var target = dc.currentTarget

                                      if(BrushingDataSet.currentGraphID!=id)
                                      {
                                        clearAllBrushes()
                                      }
          
                                      if (target.classList.contains('brushon')) {
                                            target.classList.remove('brushon')
                                            var brushingPointsBarPlotArray = brushingDataset.getBrushingBarChartArray();
          
                                         
                                            brushingPointsBarPlotArray.delete(d.name);
                                        
                                            target.setAttribute('style', "fill:" + REALDATA_COLOR)
                                            if (brushingPointsBarPlotArray.size == 0) {
            
                                                brushBarEmpty()

                                                var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                                if(logevents)
                                                {
                                                    var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                                    logevents._logEvents.push(event)
                                                    sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                                }

                                                BrushingDataSet.currentGraphID = id
                                                BrushingDataSet.currentGraphType = BAR_CHART
                                                BrushingDataSet.currentGraphData = null
                                                BrushingDataSet.currentGraphEnable = 2
                                                

                                                barChartBrush(
                                                    2,
                                                    id,
                                                    null,
                                                  brushingDataset
                                                
                                              );
          
                                          }
                                          else {
                                            
                                            var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                            if(logevents)
                                            {
                                                var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                                logevents._logEvents.push(event)
                                                sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                            }

                                            BrushingDataSet.currentGraphID = id
                                            BrushingDataSet.currentGraphType = BAR_CHART
                                            BrushingDataSet.currentGraphData = brushingPointsBarPlotArray
                                            BrushingDataSet.currentGraphEnable = 0

                                              barChartBrush(
                                                  0,
                                                  id,
                                                  brushingPointsBarPlotArray,
                                                  brushingDataset,
                                               
                                              )
          
                                          }
          
          
                                      }
                                      else {
                                          target.classList.add('brushon')
                                          target.setAttribute('style', "fill:" + BRUSHING_COLOR)
                                          brushBar(xaxis, yaxis)
          
                                          var brushingPointsBarPlotArray = brushingDataset.getBrushingBarChartArray();
          
          
                                          brushingPointsBarPlotArray.add(d.name)

                                          var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                          if(logevents)
                                          {
                                              var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                              logevents._logEvents.push(event)
                                              sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                          }

                                          BrushingDataSet.currentGraphID = id
                                          BrushingDataSet.currentGraphType = BAR_CHART
                                          BrushingDataSet.currentGraphData = brushingPointsBarPlotArray
                                          BrushingDataSet.currentGraphEnable = 0

                                          barChartBrush(
                                              0,
                                              id,
                                              brushingPointsBarPlotArray,
                                              brushingDataset,
                                             
                                          )
          
          
          
                                      }
          
          
                                  }}
                                ></rect>
                                <rect
                                    fill={PREDICTION_COLOR}
                                    x={xScale1("prediction")}
                                    y={yScale(d.prediction)}
                                    width={xScale1.bandwidth()}
                                    className={id+"_predictRect_"+d.name}
                                    height={height - yScale(d.prediction)}
                                ></rect>
                            </g>
                        </>
                    );
                } else {
                    return (
                        <>
                            <g transform={"translate(" + xScale0(d.name) + ",0)"}>
                                <rect
                                    fill={REALDATA_COLOR}
                                    id={id + '#' + '_BarChart_' + xaxis + "_" + yaxis + "_" + d.name}
                                    className={['BarChart_' + xaxis + "_" + yaxis + "_" + d.name+"_"+id, d.name, 'axis--x'].join(" ")}
                                    x={xScale1("actual")}
                                    y={yScale(d.actual)}
                                    width={xScale1.bandwidth()}
                                    height={height - yScale(d.actual)}
                                    onClick={function(dc) {

                                      var target = dc.currentTarget

                                      if(BrushingDataSet.currentGraphID!=id)
                                      {
                                        clearAllBrushes()
                                      }
          
                                      if (target.classList.contains('brushon')) {
                                          target.classList.remove('brushon')
                                          var brushingPointsBarPlotArray = brushingDataset.getBrushingBarChartArray();
          
                                          brushingPointsBarPlotArray.delete(d.name);

                                          target.setAttribute('style', "fill:" + REALDATA_COLOR)
                                          if (brushingPointsBarPlotArray.size == 0) {
          
                                              brushBarEmpty()

                                              var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                              if(logevents)
                                              {
                                                  var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                                  logevents._logEvents.push(event)
                                                  sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                              }

                                              BrushingDataSet.currentGraphID = id
                                              BrushingDataSet.currentGraphType = BAR_CHART
                                              BrushingDataSet.currentGraphData = null
                                              BrushingDataSet.currentGraphEnable = 2
                                              barChartBrush(
                                                  2,
                                                  id,
                                                  null,
                                                  brushingDataset,
                                                
                                              );
          
                                          }
                                          else {

                                            var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                            if(logevents)
                                            {
                                                var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                                logevents._logEvents.push(event)
                                                sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                            }

                                            BrushingDataSet.currentGraphID = id
                                            BrushingDataSet.currentGraphType = BAR_CHART
                                            BrushingDataSet.currentGraphData = brushingPointsBarPlotArray
                                            BrushingDataSet.currentGraphEnable = 0
                                              barChartBrush(
                                                  0,
                                                  id,
                                                  brushingPointsBarPlotArray,
                                                  brushingDataset,
                                                
                                              )
          
                                          }
          
          
                                      }
                                      else {
                                          target.classList.add('brushon')
                                          target.setAttribute('style', "fill:" + BRUSHING_COLOR)
                                          brushBar(xaxis, yaxis)
          
                                          var brushingPointsBarPlotArray = brushingDataset.getBrushingBarChartArray();
          
          
                                          brushingPointsBarPlotArray.add(d.name)

                                          var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                          if(logevents)
                                          {
                                              var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                              logevents._logEvents.push(event)
                                              sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                          }

                                          BrushingDataSet.currentGraphID = id
                                            BrushingDataSet.currentGraphType = BAR_CHART
                                            BrushingDataSet.currentGraphData = brushingPointsBarPlotArray
                                            BrushingDataSet.currentGraphEnable = 0

                                          barChartBrush(
                                              0,
                                              id,
                                              brushingPointsBarPlotArray,
                                              brushingDataset,
                                             
                                          )
          
          
          
                                      }
          
          
                                  }}
                                ></rect>
                                <rect
                                    fill={NO_PREDICTION_COLOR}
                                    x={xScale1("prediction")}
                                    y={yScale(d.prediction)}
                                    width={xScale1.bandwidth()}
                                    height={height - yScale(d.prediction)}
                                ></rect>
                            </g>
                        </>
                    );
                }
            });

            React.useEffect(() => {
                console.log("useEffectBarChart");
                console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);
                console.log("useEffectBarChart", BrushingDataSet.currentGraphType,graphOptions, )
                console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);


                

    
                if (
                    graphOptions == PREDICTION && document.getElementById(id + "_svg_barchart_draw")
                ) {
    
                    interactfuncs.resizeTopRectBar(id + "_predictRect", xaxis, yaxis, graphType);
                }
    
                if (
                    graphOptions == SEEDATA 
                  )
                  {
                 
                      if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
                      {
                        
                        histogramBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                      if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
                      {
                        
                        scatterPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                      if(BrushingDataSet.currentGraphType == BAR_CHART)
                      {
                        
                        barChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                      if(BrushingDataSet.currentGraphType == LINE_CHART)
                      {
                        
                        lineChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                    
                  }
            }, [graphType, graphOptions, width, height, yaxis]);

            return (
                <>

                    <svg
                        className={id + "chart"}
                        id={id + "_svg_barchart_draw"}
                        height={height + margin.left + margin.right}
                        width={width + margin.top + margin.bottom}
                    >
                        <g
                            transform={"translate(" + margin.left + ", " + margin.top + ")"}
                            id={id + "_svg_barchart"}
                        >
                            <g
                                transform={"translate(0," + height + ")"}
                                ref={node => d3Select(node).call(xAxis_combined)}
                                
                            ></g>
                            <g ref={node => d3Select(node).call(yAxis)} className={'axisY'}></g>
                            {rectBackground}
                        </g>
                    </svg>
                </>
            );
        }
        else {
            actualDataset.setlinearYScale(linearYScale)
            console.log('categoriesMapcategoriesMapcategoriesMap', categoriesMap)
            rectForeground = Object.keys(categoriesMap).map(function(e) {

                return (
                    <rect

                        fill={REALDATA_COLOR}
                        id={id + '#' + '_BarChart_' + xaxis + "_" + yaxis + "_" + e}

                        className={["BarChart " + e + " BarChart_" + xaxis + "_" + yaxis + "_" + e+"_"+id, 'BarChart_' + xaxis + "_" + e, e].join(" ")}
                        x={xScaleBand(e)}
                        y={linearYScale(categoriesMap[e])}
                        width={xScaleBand.bandwidth()}
                        height={height - linearYScale(categoriesMap[e])}
                        onClick={function(d) {

                            var target = d.currentTarget

                            if(BrushingDataSet.currentGraphID!=id)
                            {
                            clearAllBrushes()
                            }

                            if (target.classList.contains('brushon')) {
                                target.classList.remove('brushon')
                                var brushingPointsBarPlotArray = brushingDataset.getBrushingBarChartArray();

                             
                                brushingPointsBarPlotArray.delete(e);


                               

                                target.setAttribute('style', "fill:" + REALDATA_COLOR)
                                if (brushingPointsBarPlotArray.size == 0) {

                                    brushBarEmpty()

                                    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                    if(logevents)
                                    {
                                        var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                        logevents._logEvents.push(event)
                                        sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                    }

                                    BrushingDataSet.currentGraphID = id
                                    BrushingDataSet.currentGraphType = BAR_CHART
                                    BrushingDataSet.currentGraphData = null
                                    BrushingDataSet.currentGraphEnable = 2

                                    barChartBrush(
                                        2,
                                        id,
                                        null,
                                        brushingDataset,
                                       
                                    );

                                }
                                else {

                                    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                    if(logevents)
                                    {
                                        var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                        logevents._logEvents.push(event)
                                        sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                    }

                                    BrushingDataSet.currentGraphID = id
                                    BrushingDataSet.currentGraphType = BAR_CHART
                                    BrushingDataSet.currentGraphData = brushingPointsBarPlotArray
                                    BrushingDataSet.currentGraphEnable = 0

                                    barChartBrush(
                                        0,
                                        id,
                                        brushingPointsBarPlotArray,
                                        brushingDataset,
                                      
                                    )

                                }


                            }
                            else {
                                target.classList.add('brushon')
                                target.setAttribute('style', "fill:" + BRUSHING_COLOR)
                                brushBar(xaxis, yaxis)

                                var brushingPointsBarPlotArray = brushingDataset.getBrushingBarChartArray();

                                



                                brushingPointsBarPlotArray.add(e)


                                var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                                if(logevents)
                                {
                                    var event = LogEvents.addEvent(id, BAR_CHART,LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, SEEDATA, null, brushingPointsBarPlotArray,xaxis,yaxis,null)
                                    logevents._logEvents.push(event)
                                    sessionStorage.setItem('logevents', JSON.stringify(logevents))
                                }

                                BrushingDataSet.currentGraphID = id
                                BrushingDataSet.currentGraphType = BAR_CHART
                                BrushingDataSet.currentGraphData = brushingPointsBarPlotArray
                                BrushingDataSet.currentGraphEnable = 0
                                
                                barChartBrush(
                                    0,
                                    id,
                                    brushingPointsBarPlotArray,
                                    brushingDataset,
                                  
                                )



                            }


                        }}

                    ></rect>
                );


            });


            React.useEffect(() => {
                console.log("useEffectBarChart");
                console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);
                console.log("useEffectBarChart", BrushingDataSet.currentGraphType,graphOptions, )
                console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);
    
              
    
                if (
                    graphOptions == SEEDATA 
                  )
                  {
                        
                      if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
                      {
                        
                        histogramBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                      if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
                      {
                        
                        scatterPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                      if(BrushingDataSet.currentGraphType == LINE_CHART)
                      {
                        
                        lineChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                      if(BrushingDataSet.currentGraphType == BAR_CHART)
                      {
                        
                        barChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
                      }
                      if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
                      {
                        
                        parallelCoordinatesPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData);
                      }
                      
                    
                  }
            }, [graphType, graphOptions, width, height, yaxis]);

            return (
                <>
                    <svg
                        className={id + "chart"}
                        id={id + "_svg_barchart_draw"}
                        height={height + margin.left + margin.right}
                        width={width + margin.top + margin.bottom}
                    >
                        <g
                            transform={"translate(" + margin.left + ", " + margin.top + ")"}
                            id={id + "_svg_barchart"}
                            className={id}
                        >
                            <g id={id + "_svg_barchart_xaxis"} transform={"translate(0," + height + ")"}>
                                <g
                                    transform={"translate(0,0)"} className={'axis axis--x'}
                                    ref={node => d3Select(node).call(xAxis)}
                                ></g>
                            </g>

                            <g ref={node => d3Select(node).call(yAxis)} className={'axisY'}></g>

                            {rectForeground}
                        </g>
                    </svg>
                </>
            );
        }


        

    }






};
export default BarChart;

function brushBar(xaxis, yaxis) {
    brushingDataset.getBrushingBarChartAxis().xaxis = xaxis;
    brushingDataset.getBrushingBarChartAxis().yaxis = yaxis;
}

function brushBarEmpty() {
    brushingDataset.emptyBrushingBarChartArray()
}


function arrayRemove(arr, value) {

    return arr.filter(function(ele) {
        return ele != value;
    });

}


